(() => {
  "use strict";

  function initDayJourney(scope = document) {

    const sections = scope.querySelectorAll(".ecoma-day-journey");

    sections.forEach((section) => {

      const cards = section.querySelectorAll(".day-card");

      if (!cards.length) return;

      if ("IntersectionObserver" in window) {

        const observer = new IntersectionObserver((entries) => {

          entries.forEach((entry) => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add("is-visible");

            observer.unobserve(entry.target);

          });

        }, {
          threshold: 0.15,
          rootMargin: "0px 0px -80px 0px"
        });

        cards.forEach((card) => {

          card.classList.remove("is-visible");

          observer.observe(card);

        });

      } else {

        cards.forEach((card) => {

          card.classList.add("is-visible");

        });

      }

    });

  }

  document.addEventListener("DOMContentLoaded", () => {
    initDayJourney();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initDayJourney(event.target);
  });

  document.addEventListener("shopify:section:reorder", () => {
    initDayJourney();
  });

})();